import {
  Box,
  Card,
  CircularProgress,
  Stack,
  Typography,
  useMediaQuery,
} from "@mui/material";
import moment from "moment";
import React from "react";
import NoTasksFound from "src/pages/dashboard/components/NoTasksFound";
import RecurringEventCard from "./RecurringEventCard";
import DashboardTaskCard from "src/pages/dashboard/components/DaashboardTaskCard";

export default function WeekCalendar({
  events,
  currentDate,
  loading,
  recurringEvents,
}) {
  console.log(events);
  const is_mobile_view = useMediaQuery("(max-width:600px)");
  const getByWeek = (events) => {
    // Define the start and end dates of the range
    const startDate = moment(currentDate.start_date, "YYYY-MM-DD");
    const endDate = moment(currentDate.end_date, "YYYY-MM-DD");

    // Filter events within the date range
    const filteredEvents = events.filter((event) => {
      return (
        moment(event.start).isSameOrAfter(startDate) &&
        moment(event.start).isSameOrBefore(endDate)
      );
    });

    let newArray = [];
    filteredEvents.forEach((event, i) => {
      let index = newArray.findIndex(
        (new_event) =>
          moment(new_event.date).format("ddd") ==
          moment(event.start).format("ddd")
      );
      if (index > -1) {
        newArray[index].events.push(event);
      } else {
        newArray.push({
          date: event.start,
          events: [event],
        });
      }
    });
    return newArray.sort(function (a, b) {
      var dateA = new Date(a.date);
      var dateB = new Date(b.date);
      return dateA - dateB;
    });
  };

  const filterdTasks = getByWeek(events);
  const recurringFilteredEvents = getByWeek(recurringEvents);

  // ================= Merge Days Block for render ==========================
  const mergedByDate = {};

  filterdTasks.forEach((task) => {
    const taskDate = moment(task.date).format("YYYY-MM-DD");
    if (!mergedByDate[taskDate]) {
      mergedByDate[taskDate] = {
        date: task.date,
        tasks: [],
        recurringEvents: [],
      };
    }
    mergedByDate[taskDate].tasks = task.events;
  });

  recurringFilteredEvents.forEach((event) => {
    const eventDate = moment(event.date).format("YYYY-MM-DD");
    if (!mergedByDate[eventDate]) {
      mergedByDate[eventDate] = {
        date: event.date,
        tasks: [],
        recurringEvents: [],
      };
    }
    mergedByDate[eventDate].recurringEvents = event.events;
  });

  const mergedDays = Object.values(mergedByDate).sort(
    (a, b) => new Date(a.date) - new Date(b.date)
  );

  /* <<--------------------------------------------------------->> */

  return (
    <>
      {loading ? (
        <Box
          display="flex"
          justifyContent="center"
          alignItems="center"
          height="80vh"
        >
          <CircularProgress />
        </Box>
      ) : (
        <div className="row m-2">
          {mergedDays.length > 0 ? (
            <Stack spacing={2}>
              {mergedDays.map((day, index) => (
                <div key={index} className="col-12 calendar-week-card">
                  <Card sx={{ px: 2, py: 1 }}>
                    <div className="row">
                      <div className="col-12 col-sm-2 d-flex flex-column align-items-center">
                        <div className={is_mobile_view ? "pt-1" : "pt-3"}>
                          <h4>{moment(day.date).format("ddd")}</h4>
                          <span>{moment(day.date).format("MM/DD")}</span>
                        </div>
                      </div>
                      <div className="col-12 col-sm-10 p-1">
                        <Stack spacing={1}>
                          {day.tasks.map((task, indx) => (
                            <div key={indx}>
                              <DashboardTaskCard
                               task={task.more}
                               showIcon={true}
                              />
                            </div>
                          ))}
                          {day.recurringEvents.map((event, i) => (
                            <div key={i}>
                              <RecurringEventCard event={event} />
                            </div>
                          ))}
                        </Stack>
                      </div>
                    </div>
                  </Card>
                </div>
              ))}
            </Stack>
          ) : (
            <div className="d-flex justify-content-center align-items-center">
              <NoTasksFound />
            </div>
          )}
        </div>
      )}
    </>
  );
}
